import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CurrentScopeFacade } from '@principle-theorem/ng-principle-shared';
import { DialogPresets } from '@principle-theorem/ng-shared';
import { Practice } from '@principle-theorem/principle-core';
import { filterUndefined, snapshot } from '@principle-theorem/shared';
import { first } from 'lodash';
import {
  ISelectVerifoneTerminalDialogData,
  SelectVerifoneTerminalComponent,
  toSelectedVerifoneTerminal,
  type ISelectedVerifoneTerminal,
} from './select-verifone-terminal.component';

@Injectable()
export class SelectVerifoneTerminalService {
  constructor(
    private _dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private _currentScopeFacade: CurrentScopeFacade
  ) {}

  async getTerminalData(): Promise<ISelectedVerifoneTerminal | undefined> {
    const practice = await snapshot(
      this._currentScopeFacade.currentPractice$.pipe(filterUndefined())
    );
    const terminals = await snapshot(Practice.verifoneTerminals$(practice));

    if (terminals.length === 0) {
      this._snackBar.open(
        'No Verifone terminals configured. Please pair a terminal in practice settings.',
        'Dismiss',
        { duration: 5000 }
      );
      return;
    }

    if (terminals.length === 1) {
      const terminal = first(terminals);
      if (!terminal) {
        return;
      }
      const selected = toSelectedVerifoneTerminal({
        terminal,
        practiceRef: practice.ref,
      });
      if (!selected) {
        this._snackBar.open(
          'Terminal has not been paired yet. Please pair the terminal before processing a payment.',
          'Dismiss',
          { duration: 5000 }
        );
        return;
      }
      return selected;
    }

    return this._dialog
      .open<
        SelectVerifoneTerminalComponent,
        ISelectVerifoneTerminalDialogData,
        ISelectedVerifoneTerminal
      >(
        SelectVerifoneTerminalComponent,
        DialogPresets.small({
          data: { terminals },
        })
      )
      .afterClosed()
      .toPromise();
  }
}
